/* eslint-disable */
import Vue from 'vue'

let moveX, moveY, moveAll

export default function draggable (el, binding, vnode) {
    el.style.cursor = '-webkit-grab'

    let instance = vnode.componentInstance || vnode.context

    let modifiers = binding.modifiers
    if (modifiers.x || modifiers.y) {
        if (modifiers.x) {
            moveX = true
        }
        if (modifiers.y) {
            moveY = true
        }
    } else {
        moveAll = true
    }

    addListener(el, 'mousedown', onMousedown.bind(el))
    addListener(el, 'mouseup', onMouseup.bind(el))
    addListener(el, 'mousemove', onMousemove.bind(el))
    addListener(el, 'mouseleave', onMouseup.bind(el))

    if (binding.arg && binding.value) {
        switch (binding.arg) {
            case 'start':
                _removeAndAdd('mousedown', onMousedown)
                break
            case 'end':
                _removeAndAdd('mouseup', onMouseup)
                break
            case 'move':
                _removeAndAdd('mousemove', onMousemove)
                break
            default:
                break;
        }
    }

    function _removeAndAdd (eventName, oldFn) {
        removeAndAdd(
            el, 
            eventName, 
            oldFn, 
            getHandler(oldFn.bind(el), binding.value) 
        )
    }
}

function addListener (el, eventName, fn) {
    el.addEventListener(eventName, fn)
}

function removeListener (el, eventName, fn) {
    el.removeEventListener(eventName, fn)
}

/*
 * @param {HTMLElement} el 
 * @param {String} eventName 
 * @param {Function} oldFn 
 * @param {Function} newFn 
 */
function removeAndAdd (el, eventName, oldFn, newFn) {
    removeListener(el, eventName, oldFn)
    addListener(el, eventName, newFn)
}

function getHandler (fn, ...params) {
    return function (event) {
        fn(event, ...params)
    }
}

/**
 * @param {MouseEvent} event 
 * @param {HTMLElement} el 
 */
function getEvent (event, el) {
    return {
        el,
        x: event.screenX,
        y: event.screenY,
        initX: parseFloat(el.dataset.initX),
        initY: parseFloat(el.dataset.initY),
        moveX: event.screenX - el.dataset.initX,
        moveY: event.screenY - el.dataset.initY
    }
}

function onMousedown (event, cb) {
    this.style.cursor = '-webkit-grabbing'    
    this.dataset.dragging = 1
    this.dataset.initX = event.screenX
    this.dataset.initY = event.screenY

    cb && cb(getEvent(event, this))
}

function onMouseup (event, cb) {
    this.style.cursor = '-webkit-grab'
    this.dataset.dragging = 0

    cb && cb(getEvent(event, this))
}

function onMousemove (event, cb) {
    if (this.dataset.dragging == 1) {
        let relX = event.screenX - this.dataset.initX
        let relY = event.screenY - this.dataset.initY

        if (moveAll || (moveX && moveY)) {
            this.style.transform = `translate(${relX}px, ${relY}px)`
        } else if (moveX && !moveY) {
            this.style.transform = `translateX(${relX}px)`            
        } else if (moveY && !moveX) {
            this.style.transform = `translateY(${relY}px)`            
        }
    } else {
        return false
    }

    cb && cb(getEvent(event, this))
}


// WEBPACK FOOTER //
// ./src/_fdp/core/directive/drag/draggable.js